import React, { Component } from 'react';

export default class ErrorHandler extends Component{
    render(){
        return (
            <div>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/error-handler/ErrorHandler.jsx